import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import { makeStyles } from "@material-ui/styles";
import PlayCircleFilledIcon from "@material-ui/icons/PlayCircleFilled";
import CloseIcon from "@material-ui/icons/Close";
import ProgressBar from "./ProgressBar";
import { IconButton, Typography } from "@material-ui/core";
import axios from "axios";
import _ from "lodash";
import moment from "moment";
import PauseIcon from "@material-ui/icons/Pause";
import config from "./config.json";
import useGlobalContext from "./Context/useGlobalContext";
import ReplaySpeedPopUp from "./commonComponents/ReplaySpeedPopUp";
const speeds = [
  {
    speed: 1000,
    label: "1X",
    value: "1x",
    pollInterval: 30,
    pollDataLength: 40,
  },
  {
    speed: 500,
    label: "2X",
    value: "2x",
    pollInterval: 40,
    pollDataLength: 60,
  },
  {
    speed: 250,
    label: "4X",
    value: "4x",
    pollInterval: 40,
    pollDataLength: 80,
  },
];

let currentSpeed = speeds[0];
let currentResponseData: any[] = [];
let currentTimestamp: number = 0;
let currentSec = 0;
let initialTimestamp: number = 0;

const ignoreData: {
  key: string;
  values: any[]
}[] = config.ignore || [];

const replayUrl = config.replayURL;
const bgColor = config.backgroundColor;

const ReplayPlayer = (props, ref) => {
  const [currentDataItem, setCurrentDataItem] = useState({
    records: [] as any[],
    timestamp: Date.now() / 1000,
    isPaused: true,
  });
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const open = Boolean(anchorEl);
  const id = open ? "simple-colorPicker" : undefined;
  const timerRef: any = useRef();
  const {
    isLive,
    isLiveRef,
    bulkUpdate,
    setFlightFeatureCollection,
    flightFeatureCollection,
    setIsLive,
    setIsLoading,
  } = useGlobalContext();
  let styles = useStyles();



  useEffect(() => {
    bulkUpdate(
      currentDataItem.records,
      moment(currentDataItem.timestamp * 1000).format("MM/DD/YYYY h:mm:ss a")
    );
  }, [currentDataItem]);

  useEffect(() => {
    return () => {
      clearInterval(timerRef.current);
    };
  }, []);

  const initPlayer = async (timestamp) => {
    setIsLoading(true);
    currentResponseData = await fetchData(
      timestamp,
      currentSpeed.pollDataLength
    );
    setIsLoading(false);
    callSetInterval(currentSpeed.speed);
  };

  const callSetInterval = (intervalTime) => {
    if (timerRef.current) {
      clearInterval(timerRef.current);
    }
    timerRef.current = setInterval(async () => {
      const filteredData = currentResponseData.filter((item) => {
        if (item?.timestamp) {
          if (item.timestamp.toString().length === 10) {
            if (_.toNumber(item.timestamp) === _.toNumber(currentTimestamp)) {
              return true;
            } else {
              return false;
            }
          } else {
            if (
              Math.round(_.toNumber(item.timestamp) / 1000) ===
              _.toNumber(currentTimestamp)
            ) {
              return true;
            } else {
              return false;
            }
          }
        }
      });

      currentTimestamp = _.toNumber(currentTimestamp) + 1;
      setCurrentDataItem({
        ...currentDataItem,
        records: filteredData,
        timestamp: currentTimestamp,
        isPaused: false,
      });
      currentSec++;
      if (
        currentSpeed.pollInterval === currentSec ||
        currentSec > currentSpeed.pollInterval
      ) {
        currentSec = 0;
        const nextData = await fetchData(
          convertSecToMilli(currentTimestamp),
          currentSpeed.pollDataLength
        );
        const newData = currentResponseData.filter((item) => {
          if (item.timestamp.length === 10) {
            return _.toNumber(item.timestamp) >= _.toNumber(currentTimestamp);
          } else {
            return (
              Math.round(_.toNumber(item.timestamp) / 1000) >=
              _.toNumber(currentTimestamp)
            );
          }
        });
        currentResponseData = newData;
        currentResponseData = [...currentResponseData, ...nextData];
      }
    }, intervalTime);
  };
  const startPlayer = (timeStamp) => {
    resetAll();
    initialTimestamp = timeStamp;
    currentTimestamp = convertMilliToSec(timeStamp);
    initPlayer(timeStamp);
  };

  const fetchData = async (timeStamp, interval) => {
    if (replayUrl) {
      const apiRoute = isLiveRef.current ? "live" : "history";
      const url = `${replayUrl}api/player/${apiRoute}?start=${timeStamp}&seconds=${interval}`;
      const result = await axios.get(url);
      const finalResult: any = [];

      if (result.data && Array.isArray(result.data)) {
        result.data.map((item) => {
          if (isLiveRef.current) {
            item = JSON.parse(item);
          }
          if (item?.data) {
            if (isLiveRef.current) {
              finalResult.push(JSON.parse(item.data));
            } else {
              finalResult.push(item.data);
            }
          } else {
            item = {
              ...item,
              timestamp: _.toNumber(item.timestamp),
              _uid: `${item.uid}-${item.aid}`,
              lat: _.toNumber(item.lat),
              long: _.toNumber(item.lng),
            };
            finalResult.push(item);
          }
        });
      }

      const filteredData = finalResult.filter((fltData) => {
        return !ignoreData.some((ignore) => {
          if (fltData[ignore.key] !== undefined) {
            return ignore.values.includes(fltData[ignore.key]);
          } else {
            return false;
          }
        });
      });
      return filteredData;
    } else {
      return [];
    }
  };

  useImperativeHandle(ref, () => ({
    startPlayer: startPlayer,
  }));

  const resetAll = () => {
    if (timerRef.current) {
      clearInterval(timerRef.current);
    }
    currentSpeed = speeds[0];
    currentResponseData = [];
    currentSec = 0;
    currentTimestamp = 0;
    initialTimestamp = 0;
    setCurrentDataItem({
      records: [],
      timestamp: Date.now() / 1000,
      isPaused: true,
    });
  };

  const onClickSpeed = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const onClickSpeedItem = (index) => {
    currentSpeed = speeds[index];
    currentSec = currentSpeed.pollInterval + 1;
    callSetInterval(speeds[index].speed);
    setAnchorEl(null);
  };

  const popperContent = () => (
    <div className={styles.poperContainer}>
      <div className={styles.speedTextContainer}>
        <Typography className={styles.speedText}>Speed</Typography>
      </div>
      {speeds.map((item, index) => (
        <Typography
          className={styles.content}
          key={item.speed}
          onClick={() => onClickSpeedItem(index)}
        >
          {item.label}
        </Typography>
      ))}
    </div>
  );

  const onClickClose = () => {
    resetAll();
    setFlightFeatureCollection({
      type: "FeatureCollection",
      features: [],
    });
    setIsLive(true);

    startPlayer(Date.now() - 120000);
  };

  const closeExpanded = () => {
    setAnchorEl(null);
  };

  const onClickPlayOrPause = () => {
    if (currentDataItem.isPaused) {
      callSetInterval(currentSpeed.speed);
    } else {
      pausePlayer();
    }
  };

  const pausePlayer = () => {
    if (timerRef.current) {
      clearInterval(timerRef.current);
    }
    setCurrentDataItem({
      ...currentDataItem,
      isPaused: true,
    });
  };

  const getProgressValue = () => {
    const endTimeStamp = initialTimestamp + 3600 * 1000;
    const diff = endTimeStamp - initialTimestamp;
    const diffCurrTime = currentTimestamp * 1000 - initialTimestamp;
    return diffCurrTime / diff;
  };

  const onChangeProgressBar = async (percentage) => {
    if (percentage > 0) {
      currentSec = 0;
      pausePlayer();
      const endTimeStamp = initialTimestamp + 3600 * 1000;
      const diff = endTimeStamp - initialTimestamp;
      const percentageValue = (diff / 100) * percentage;
      currentTimestamp = convertMilliToSec(percentageValue + initialTimestamp);
      setCurrentDataItem({
        ...currentDataItem,
        timestamp: currentTimestamp,
      });
      await initPlayer(convertSecToMilli(currentTimestamp));
    }
  };

  const convertSecToMilli = (value) => {
    return _.toNumber(value) * 1000;
  };

  const convertMilliToSec = (value) => {
    return Math.round(_.toNumber(value) / 1000);
  };

  if (getProgressValue() === 1) {
    if (!currentDataItem.isPaused) {
      pausePlayer();
    }
  }

  if (isLive) {
    return null;
  }

  return (
    <div className={styles.container}>
      <div className={styles.iconOuterContainer}>
        <IconButton
          className={styles.iconContainer}
          onClick={onClickPlayOrPause}
        >
          {currentDataItem.isPaused ? (
            <PlayCircleFilledIcon className={styles.icon} />
          ) : (
            <PauseIcon className={styles.icon} />
          )}
        </IconButton>
      </div>
      <div className={styles.speedContainer}>
        <Typography onClick={onClickSpeed} className={styles.currentSpeedText}>
          {currentSpeed.value}
        </Typography>
        <ReplaySpeedPopUp
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={closeExpanded}
        >
          {popperContent()}
        </ReplaySpeedPopUp>
      </div>
      <div className={styles.progressBarContainer}>
        {/* <Typography className={styles.timer}>
          {moment(currentDataItem.timestamp * 1000).format(
            "MM/DD/YYYY h:mm:ss a"
          )}
        </Typography> */}
        <ProgressBar
          value={getProgressValue()}
          onChangeValue={(value) =>
            onChangeProgressBar(Math.round(value * 100))
          }
        />
      </div>
      <div className={styles.closeContainer}>
        <IconButton
          className={styles.closeIconContainer}
          onClick={onClickClose}
        >
          <CloseIcon className={styles.icon} />
        </IconButton>
      </div>
    </div>
  );
};
const useStyles = makeStyles(() => {
  return {
    container: {
      borderRadius: "5px",
      width: window.screen.width - 103,
      height: "8vh",
      display: "flex",
      alignItems: "center",
      marginLeft: 103,
    },
    iconOuterContainer: {
      width: "5%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    progressBarContainer: {
      width: "85%",
      height: 30,
      display: "flex",
      alignItems: "center",
      flexDirection: "column",
      justifyContent: "center",
    },
    iconContainer: {
      color: bgColor,
      width: "100%",
      height: "100%",
    },
    icon: {
      height: "100%",
    },
    speedContainer: {
      width: "5%",
      display: "flex",
      alignItems: "center",
    },
    poperContainer: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
    },
    speedText: {},
    speedTextContainer: {
      padding: 10,
    },

    content: {
      padding: 10,
      cursor: "pointer",
    },
    currentSpeedText: {
      cursor: "pointer",
    },
    closeContainer: {
      width: "5%",
      alignItems: "center",
      justifyContent: "center",
      display: "flex",
    },
    timer: {
      marginBottom: 5,
      color: "black",
    },
    closeIconContainer: {
      color: bgColor,
      width: "100%",
      height: "100%",
    },
  };
});

export default forwardRef(ReplayPlayer);
